import React from 'react';

const MyTextChatContainer = ({ message, time, showTime = true }) => {
  const formatTime = (timeString) => {
    if (!timeString) return '';
    const date = new Date(timeString);
    return date.toLocaleTimeString('ko-KR', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div className="flex justify-end mb-1">
      <div className="flex items-end" style={{ maxWidth: '70%' }}>
        {/* 시간 */}
        {showTime && (
          <div className="flex flex-col items-end mr-2 text-xs text-gray-500">
            <span>{formatTime(time)}</span>
          </div>
        )}

        {/* 말풍선 */}
        <div className="bg-amber-200 border border-amber-300 text-gray-900 rounded-2xl px-4 py-2 min-w-0">
          <p className="text-sm whitespace-pre-wrap break-all">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default MyTextChatContainer;
